import { BowlBlock } from '@websolutespa/payload-plugin-bowl';

export const Cta: BowlBlock = {
  type: 'withBlock',
  slug: 'cta',
  fields: [
    {
      name: 'title',
      type: 'text',
      required: true,
      localized: true,
    },
    {
      name: 'href',
      type: 'text',
      required: true,
      localized: true,
      admin: {
        width: '50%',
      },
    },
    {
      name: 'target',
      type: 'text',
      required: true,
      defaultValue: '_blank',
      admin: {
        width: '50%',
      },
    },
    {
      name: 'icon',
      type: 'withMedia',
    },
  ],
};
